import { connect } from 'react-redux';
import { getSubmitText, getIsPaginatedForm
// @ts-expect-error types missing
} from 'FormsUI/selectors/FormDefinition';
import { getIsPaymentsEnabled, getPaymentLabel
// @ts-expect-error types missing
} from 'FormsUI/selectors/Payments';
import SubmitButton from './SubmitButton';
import { isSubmitSelected } from 'FormsUI/utils/SpecialFields';
import { jsx as _jsx } from "react/jsx-runtime";
const SubmitButtonContainer = ({
  submitText,
  paymentLabel,
  selectedFormItemReference,
  selectedFormItemType,
  isPaymentActive,
  handleSubmitSelect
}) => {
  const isSelected = isSubmitSelected({
    selectedFormItemType,
    selectedFormItemReference
  });
  return /*#__PURE__*/_jsx(SubmitButton, {
    submitText: submitText,
    paymentLabel: paymentLabel,
    selected: isSelected,
    paymentActive: isPaymentActive,
    handleSubmitSelect: handleSubmitSelect
  });
};
const mapStateToProps = state => ({
  submitText: getSubmitText(state),
  paymentLabel: getPaymentLabel(state),
  isPaginatedForm: getIsPaginatedForm(state),
  isPaymentActive: getIsPaymentsEnabled(state)
});
const actionCreators = {};
export default connect(mapStateToProps, actionCreators)(SubmitButtonContainer);